export const TAB_NOTIFICATION_STATE = {
  Default: 'default',
  Incoming: 'incoming',
  Active: 'active',
  ScheduledCallOffer: 'scheduled-call-offer',
} as const;

export type TabNotificationState =
  (typeof TAB_NOTIFICATION_STATE)[keyof typeof TAB_NOTIFICATION_STATE];
